import { makeStyles, Theme } from "@material-ui/core/styles";
import styled from "styled-components";

const useStyles = makeStyles((theme: Theme) => ({
  iconContainer: {
    width: 64,
  },
  spacedLeft: { paddingLeft: theme.spacing(2) },
  spacedTop: { marginTop: theme.spacing(2) },
}));

interface UnlockBannerContainerProps {
  padding?: string,
}

interface TabsContainerProps {
  borderRadius?: string,
  padding?: string,
}

interface DefaultImageProps {
  borderRadius?: string,
  backgroundColor?: string,
  width: string,
  height: string,
}

export interface StyledLabelProps {
  fontSize?: number;
  fontWeight?: number;
  color?: string;
  cursor?: string;
  margin?: string;
  padding?: string;
  paddingLeft?: string;
  marginLeft?: string;
}

export const FansTabButtonContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
  margin-bottom: 4px;
  flex-grow: 1;
`;

export const TabsContainer = styled.div`
  border-radius: ${({ borderRadius }: TabsContainerProps) => borderRadius || "8px"};
  padding: ${({ padding }: TabsContainerProps) => padding || "16px 24px"};
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #FFFFFF;
`;

export const DefaultImage = styled.img`
  background-color: ${({ backgroundColor }: DefaultImageProps) => backgroundColor || 'none'};
  max-width: ${({ width }: DefaultImageProps) => width};
  max-height: ${({ height }: DefaultImageProps) => height};
  min-width: ${({ width }: DefaultImageProps) => width};
  min-height: ${({ height }: DefaultImageProps) => height};
  border-radius: ${({ borderRadius }: DefaultImageProps) => borderRadius || "0"};
  object-fit: cover;
`;

export const UnlockBannerContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ padding }: UnlockBannerContainerProps) => padding || '0px'};
`;

export default useStyles;
